import { a as __rest, l as loadable$2, _ as __assign } from './loadable.esm-c9931684.js';
import React from 'react';

var ProxyPowerfulIcon = function (_a) {
    var rest = __rest(_a, []);
    var Loaded = loadable$2(function () { return import('./PowerfulIcon-861f5176.js'); });
    return React.createElement(Loaded, __assign({}, rest));
};

export { ProxyPowerfulIcon as P };
